import React, {
    Fragment,
    useCallback,
    useContext,
    useState,
} from 'react';

import DishItemSmall from 'app/components/DishCardBasket/DishItemSmall';
import SelectMobile from 'app/components/Select';
import { mapInfotoSelect } from 'app/components/Select/potions-select-utils';

import { DialogAnimationWrapper } from 'app/components/Dialog/DialogAnimationWrapper';

import { BasketContext } from '../../BasketProvider';


const stubScrollbarsRef = {};
const stubHandler = () => {};


export function BasketDishesSPAAdapter(props) {
    const {
        locale,
        buttonsDisabled,
    } = props;

    const {
        basket: { sections },
        updateBasket,
    } = useContext(BasketContext);

    const [isPortionsSelectOpen, setIsPortionsSelectOpen] = useState(false);
    const [portionsData, setPortionsData] = useState(null);

    const onClickMobilePortions = useCallback((nextPortionsData) => {
        setIsPortionsSelectOpen(true);
        setPortionsData(nextPortionsData);
    }, []);

    const onCloseMobilePortions = useCallback(() => {
        setIsPortionsSelectOpen(false);
    }, []);

    const handleChangePortion = useCallback((portionsIndex) => {
        const { portions, id } = portionsData;
        const nextPortions = portions[portionsIndex];
        updateBasket({ dishId: id, portions: nextPortions });

        onCloseMobilePortions();
    }, [portionsData, updateBasket, onCloseMobilePortions]);

    const handleClickRemove = useCallback((dishId) => {
        const nextCount = 0;
        updateBasket({ dishId, portions: nextCount });
    }, [updateBasket]);


    const portionSelectProps = portionsData
        ? mapInfotoSelect({
            locale,
            info: portionsData,
            handleChangePortion,
            onClose: onCloseMobilePortions,
        })
        : {};

    return (
        <>
            {sections.map((basketSection) => {
                const { items, id } = basketSection;
                return (
                    <Fragment key={id}>
                        {items.map((dishItem) => {
                            const commonProps = {
                                key: dishItem.dish_id,
                                onClickMobilePortions,
                                portionAlias: null,
                                dishItem,
                                isEditEnabled: !buttonsDisabled,
                                isEditable: !buttonsDisabled,
                                isSubscriptionActivated: false,
                                onRemoveClick: handleClickRemove,
                                onChangePortion: stubHandler,
                                onTogglePortionSelect: stubHandler,
                                onClickMobileDishDetails: stubHandler,
                                scrollbarsRef: stubScrollbarsRef,
                                isLastItem: false,
                                sectionId: 'main',
                                isOneItemInCategory: false,
                                locale,
                                basketDishUiStateDispatch: stubHandler,
                                basketUiState: 'basket-dish-added',
                            };
                            return <DishItemSmall {...commonProps} />;
                        })}
                    </Fragment>
                );
            })}
            <DialogAnimationWrapper
                isOpen={isPortionsSelectOpen}
                onReject={onCloseMobilePortions}
            >
                {Boolean(portionsData) && (
                    <SelectMobile
                        {...portionSelectProps}
                    />
                )}
            </DialogAnimationWrapper>
        </>
    );
}
